import { render, staticRenderFns } from "./BuildTypeAdd.vue?vue&type=template&id=4152e70f&scoped=true"
import script from "./BuildTypeAdd.vue?vue&type=script&lang=js"
export * from "./BuildTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152e70f",
  null
  
)

export default component.exports